// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importez les nouvelles traductions
import translationFR from '../translations/fr.json';
import translationEN from '../translations/en.json';
import translationES from '../translations/es.json';
import translationPT from '../translations/pt.json';

// Ajoutez les nouvelles langues aux ressources
const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  es: { translation: translationES },
  pt: { translation: translationPT }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    },
    // Forcer l'utilisation de codes de langue courts (fr au lieu de fr-FR)
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;